<template>
  <div class="tag" :class="{debug}" @click="clear">
    <div class="label">{{ tag.label }}</div>
    <div class="action">
      <CloseColorable/>
    </div>
  </div>
  

</template>

<script>
import * as types from '@/store/mutations'
import CloseColorable from '@/components/core/CloseColorable.vue'
export default {
  name: 'TagClearable',
  props: {
    debug: Boolean,
    tag: Object,
  },
  components: { CloseColorable },
  methods: {
    clear(){
      this.$store.commit(types.CLEAR_FILTER_TAG, this.tag.id)
    }
  }
}
</script>

<style lang="css" scoped>
.tag {
  height: 23px;
  border-radius: 8px;
  color: white;
  border: 1px solid;
  border-color: #E77423;
  background-color: #E77423;
  display: inline-flex;
  font-weight: 600;
  font-size: 12px;
  transition:  background-color 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.12s;
  align-items: center;
  padding-left: 8px;
  cursor: pointer;
  margin: 8px;
  white-space: nowrap;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16);
}


.tag .action {
  color: white;
  padding-left: 4px;
  padding-right: 7px;
  height: 100%;
  display: flex;
  align-items: center;
}

.tag:hover {
  background-color: white;
  color: #E77423;
  border-color:  #E77423;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}
.tag:hover .action {
  color: #E77423;
}
.tag:active {
  background-color: rgba(231, 116, 35, 0.1);
  box-shadow: 0 0 6px rgba(0,0,0,0);
  color: #E77423;
}
.tag:active .action {
  color: #E77423;
}

</style>
